'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _events = require('./events');

var Events = _interopRequireWildcard(_events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An API client for the Deskpro API. Application code can use it to interact with the Deskpro instance hosting the app
 *
 * @class
 */
var DeskproAPIClient = function () {
  /**
   * @param {AppEventEmitter} eventDispatcher the outgoing event dispatcher
   */
  function DeskproAPIClient(eventDispatcher) {
    var _this = this;

    (0, _classCallCheck3.default)(this, DeskproAPIClient);

    this['delete'] = function (path) {
      return _this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, { method: 'delete', path: path });
    };

    this.props = { eventDispatcher: eventDispatcher };
  }

  /**
   * @method
   *
   * @param {string} url
   * @param {object} init
   *
   * @return {Promise<DeskproAPIResponse, Error>}
   */


  (0, _createClass3.default)(DeskproAPIClient, [{
    key: 'fetch',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, init) {
        var request;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = { url: url, init: init };
                return _context.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_FETCH, request));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: 'fetchCORS',


    /**
     * An alias for fetchProxy
     *
     * @method
     * @deprecated
     * @internal
     *
     * @param {string} url the resource's relative url
     * @param {object} init a fetch init object. See {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch}
     *
     * @return {Promise<DeskproAPIResponse, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(url, init) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.fetchProxy(url, init));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchCORS(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchCORS;
    }()
  }, {
    key: 'fetchProxy',


    /**
     * Executes a fetch style request via the server-side proxy
     * This is useful for making secure requests or to access non-CORS enabled third parties
     *
     * @method
     *
     * @param {string} url the resource's relative url
     * @param {object} init a fetch init object. See {@link https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch}
     *
     * @return {Promise<DeskproAPIResponse, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(url, init) {
        var corsInit;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                corsInit = (0, _extends3.default)({}, init, { mode: 'cors' });
                return _context3.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_FETCH, { url: url, init: corsInit }));

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchProxy(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return fetchProxy;
    }()
  }, {
    key: 'get',


    /**
     * Executes a `GET` request
     *
     * @param {string} path the resource's relative url
     * @return {Promise<DeskproAPIResponse, Error>}
     */
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(path) {
        var request;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                request = { method: 'get', path: path };
                return _context4.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function get(_x7) {
        return _ref4.apply(this, arguments);
      }

      return get;
    }()

    /**
     * Executes a `POST` request
     *
     * @method
     *
     * @param {string} path the resource's relative url
     * @param {object} body the request body
     *
     * @return {Promise<DeskproAPIResponse, Error>}
     */

  }, {
    key: 'post',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(path, body) {
        var request;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request = { method: 'post', path: path, body: body };
                return _context5.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function post(_x8, _x9) {
        return _ref5.apply(this, arguments);
      }

      return post;
    }()

    /**
     * Executes a `PUT` request
     *
     * @method
     *
     * @param {string} path the resource's relative url
     * @param {Object} body the request body
     *
     * @return {Promise<DeskproAPIResponse, Error>}
     */

  }, {
    key: 'put',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(path, body) {
        var request;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                request = { method: 'put', path: path, body: body };
                return _context6.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function put(_x10, _x11) {
        return _ref6.apply(this, arguments);
      }

      return put;
    }()

    /**
     * Executes a `DELETE` request
     *
     * @method
     *
     * @param {String} path the resource's relative url
     * @return {Promise<DeskproAPIResponse, Error>}
     */

  }, {
    key: 'del',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(path) {
        var request;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                request = { method: 'delete', path: path };
                return _context7.abrupt('return', this.props.eventDispatcher.emitAsync(Events.EVENT_WEBAPI_REQUEST_DESKPRO, request));

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function del(_x12) {
        return _ref7.apply(this, arguments);
      }

      return del;
    }()

    /**
     * Executes a `DELETE` request
     *
     * @method
     *
     * @param {string} path the resource's relative url
     *
     * @return {Promise}
     */

  }]);
  return DeskproAPIClient;
}();

exports.default = DeskproAPIClient;

/**
 * Represents the result of applying a DOM Query Pattern with a `exists` type
 *
 * @typedef {Object} DeskproAPIResponse
 * @property {'complete'|'error'|'timeout'|'abort'|'parseerror'} status the status of the xhr request
 * @property {Object} body the json decoded body of the response
 * @property {Object} headers a map of <header name, value> the response headers
 * @property {number} statusCode the http code of the response
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/WebAPI/DeskproAPIClient.js
// module id = 314
// module chunks = 0